var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketBxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0406 7.09473L12.5233 25.5001H8.49997C8.06448 25.5005 7.63494 25.6013 7.24467 25.7945C6.85439 25.9878 6.51386 26.2683 6.24946 26.6143C5.98506 26.9604 5.8039 27.3627 5.72003 27.79C5.63615 28.2173 5.65182 28.6582 5.7658 29.0786L13.6963 58.1571C14.025 59.3557 14.738 60.4135 15.7258 61.1679C16.7136 61.9223 17.9217 62.3318 19.1646 62.3334H48.8381C51.3825 62.3334 53.6321 60.6192 54.3065 58.1542L62.237 29.0757C62.3523 28.6553 62.3689 28.2138 62.2853 27.7859C62.2018 27.358 62.0204 26.9552 61.7554 26.609C61.4904 26.2628 61.1489 25.9825 60.7577 25.7902C60.3664 25.5978 59.936 25.4985 59.5 25.5001H55.4766L44.9593 7.09473L40.0406 9.90539L48.9515 25.5001H19.0485L27.9593 9.90539L23.0406 7.09473ZM39.6666 36.8334H45.3333V51.0001H39.6666V36.8334ZM22.6666 36.8334H28.3333V51.0001H22.6666V36.8334Z",
    fill: "#8DAA6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketBxs);
export default __webpack_public_path__ + "static/media/basket-bxs.bce398cf4f236ea1658d93164caf85e2.svg";
export { ForwardRef as ReactComponent };